import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { SharedModule } from 'src/app/shared/shared.module';
import { UrlaModule } from '../urla/urla.module';
import { CdRequestWizardBaseComponent } from './components/cd-request-wizard-base/cd-request-wizard-base.component';
import { WholesaleCdWizardComponent } from './components/wholesale-cd-wizard/wholesale-cd-wizard.component';
import { BrokerInformationComponent } from './components/wholesale-cd-wizard/steps/broker-information/broker-information.component';
import { DocOrderFeesComponent } from './components/wholesale-cd-wizard/steps/doc-order-fees/doc-order-fees.component';
import { EscrowInformationComponent } from './components/wholesale-cd-wizard/steps/escrow-information/escrow-information.component';
import { LoanInformationComponent } from './components/wholesale-cd-wizard/steps/loan-information/loan-information.component';
import { PropertyInformationComponent } from './components/wholesale-cd-wizard/steps/property-information/property-information.component';
import { SellerAgentComponent } from './components/wholesale-cd-wizard/steps/seller-agent/seller-agent.component';
import { BuyerAgentComponent } from './components/wholesale-cd-wizard/steps/buyer-agent/buyer-agent.component';
import { SettlementAgentComponent } from './components/wholesale-cd-wizard/steps/settlement-agent/settlement-agent.component';
import { TitleInformationComponent } from './components/wholesale-cd-wizard/steps/title-information/title-information.component';
import { AdditionalCommentsComponent } from './components/wholesale-cd-wizard/steps/additional-comments/additional-comments.component';
import { CorrHeaderComponent } from './components/corr-icd-wizard/steps/corr-header/corr-header.component';
import { IcdPropertyInformationComponent } from 'src/app/modules/cd-request/components/corr-icd-wizard/steps/property-information/icd-property-information.component';
import { OriginationFeesComponent } from './components/corr-icd-wizard/steps/origination-fees/origination-fees.component';
import { ServicesCanShopComponent } from './components/corr-icd-wizard/steps/services-can-shop/services-can-shop.component';
import { ServicesCannotShopComponent } from './components/corr-icd-wizard/steps/services-cannot-shop/services-cannot-shop.component';
import { LenderCreditsFeesComponent } from './components/corr-icd-wizard/steps/lender-credits-fees/lender-credits-fees.component';
import { ContactInformationComponent } from './components/corr-icd-wizard/steps/contact-information/contact-information.component';
import { ReviewSubmitComponent } from './components/corr-icd-wizard/steps/review-submit/review-submit.component';
import { CorrIcdWizardComponent } from './components/corr-icd-wizard/corr-icd-wizard.component';

@NgModule({
  imports: [CommonModule, FormsModule, SharedModule, UrlaModule],
  declarations: [
    WholesaleCdWizardComponent,
    BrokerInformationComponent,
    DocOrderFeesComponent,
    EscrowInformationComponent,
    LoanInformationComponent,
    PropertyInformationComponent,
    SellerAgentComponent,
    BuyerAgentComponent,
    SettlementAgentComponent,
    TitleInformationComponent,
        AdditionalCommentsComponent,
        CorrHeaderComponent,
        IcdPropertyInformationComponent,
              OriginationFeesComponent,
              ServicesCanShopComponent,
              ServicesCannotShopComponent,
    LenderCreditsFeesComponent,
    ContactInformationComponent,
    ReviewSubmitComponent,
    CorrIcdWizardComponent
  ],
      exports: [
        WholesaleCdWizardComponent,
    BrokerInformationComponent,
    DocOrderFeesComponent,
    EscrowInformationComponent,
    LoanInformationComponent,
    PropertyInformationComponent,
    SellerAgentComponent,
    BuyerAgentComponent,
    SettlementAgentComponent,
    TitleInformationComponent,
    AdditionalCommentsComponent,
    CorrHeaderComponent,
    IcdPropertyInformationComponent,
    OriginationFeesComponent,
    ServicesCanShopComponent,
    ServicesCannotShopComponent,
    LenderCreditsFeesComponent,
    ContactInformationComponent,
    ReviewSubmitComponent,
    CorrIcdWizardComponent
  ]
})
export class CdRequestModule {}
